module.exports = __webpack_public_path__ + "img/fullScreen.d7dc746.png";